import React from 'react';
import { Mui, MuiStyles } from '@osu/react-ui';
import AuthButton from '../components/AuthButton';
import { NAVBAR_WRAPPER_ID } from '../../util/constants';
import { Link } from 'react-router-dom';
import useRoleAuthentication from "../../Authentication/hooks/useRoleAuthentication";

const createClasses = (theme) => {
  return {
    appBar: {
      top: '0',
      zIndex: theme.zIndex.appBar,
      "& a:not(:last-child)": {
        marginRight: "1rem",
      }
    },
    root: {
      flexGrow: 1
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
    },
  }
};

const LINKS = [
  { path: "/dashboard", label: "Dashboard", permission: "canSeeDashboardLink" },
  { path: "/admin/dashboard", label: "Admin Dashboard", permission: "canSeeAdminDashboardLink" },
];

export default function Navbar() {
  const classes = createClasses(MuiStyles.useTheme());

  return (
    <Mui.AppBar id={NAVBAR_WRAPPER_ID} color="inherit" sx={classes.appBar} position="sticky">
      <Mui.Toolbar>
        {LINKS.map(NavigationLink)}

        <Mui.Typography sx={{ flexGrow: 1 }} /> {/* Fill the horizontal space */}

        <AuthButton />
      </Mui.Toolbar>
    </Mui.AppBar>
  );
}

function NavigationLink({ path, label, permission }, index) {
  const auth = useRoleAuthentication();

  if (!auth[permission]) {
    return <React.Fragment key={index} />;
  }

  return <Mui.Button component={Link} key={path} to={path}>{label}</Mui.Button>
}